import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {  validateEmail } from "utils";

// import { Avatar } from "@mui/material";
import { toast } from "react-hot-toast";
// import TeacherForm from "./Sections/AddStaff/TeacherForm";
// import EvaluatorForm from "./Sections/AddStaff/EvaluatorForm";
import { Input, Select, TextArea } from "components/Form/index";
import { Button } from "components/Button/Button";
// import ReactSelect from "react-select";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";
// import { getUserTypes ,getDepartmentType,getSingleRegionStatebyid,getRegionStatesList,getTalukaListbyid} from "services/master";
// import VideoEditorForm from "./Sections/AddStaff/VideoEditorForm";
// import { addStaff } from "services/staff/staffController";
// import { encryptData } from "config/config";
// import useCookie from "hooks/useCookie";
// import { EditorState } from "draft-js";
import {
  getDistrictdropdownList,
  getStatedropdownList,
  getTalukadropdownList,
  getUserListById,
  getUserRoledropdownList,
  UpdateUser,
} from "services/usermanagement";
import useFullPageLoader from "hooks/useFullPageLoader";
// import ModeratorForm from "./Sections/AddStaff/ModeratorForm";
// import AffiliateAdmin from "./Sections/AddStaff/AffiliateAdmin";

export default function EditUser() {
  const { id } = useParams();

  const navigate = useNavigate();
  // const { cookies } = useCookie();

  const [isValidEmail, setIsValidEmail] = useState(true);
  const [mobError, setMobError] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  // const [allUserType, setAllUserType] = useState([]);
  const [staffData, setStaffData] = useState({
    firstName: "",
    lastName: "",
    // userName: "",
    role: "",
    department: "",
    EmployeeCode: "",
    courseCategory: [],
    centerId: "",
    type: [],
    mobile: "",
    email: "",
    address: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    zipcode: "",
  });

  const [errorField, setErrorField] = useState({
    firstName: "",
    lastName: "",
    // userName: "",
    profile: "",
    role: "",
    department: "",
    EmployeeCode: "",
    courseCategory: "",
    centerId: "",
    type: "",
    mobile: "",
    email: "",
    address: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    zipcode: "",
  });

  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allTalukas, setAllTalukas] = useState([]);
  const [allRoles, setAllRoles] = useState([]);

  // ****************************** Fetch All Data *****************************************

  const fetchAllData = async () => {
    showLoader();
    try {
      const res = await getUserListById({ UserID: id });
      hideLoader();
      console.log(res.data.user)
      if (res.code === 200) {
        setStaffData({
          ...staffData,
          firstName: res.data.user.FirstName,
          lastName: res.data.user.LastName,
          role: res.data.user.UserTypeID,
          EmployeeCode: res.data.user.EmployeeCode,
          mobile: res.data.user.Mobile,
          email: res.data.user.EmailID,
          address: res.data.user.Address,
          state: res.data.user.State,
          district: res.data.user.District,
          taluka: res.data.user.Taluka,
          city: res.data.user.City,
          zipcode: res.data.user.ZipCode,
          worklocation:res.data.user.WorkLocation      
        });
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
console.log("s",staffData)
  // ****************************** Fetch All States *****************************************

  const fetchAllStates = async () => {
    showLoader();
    try {
      const res = await getStatedropdownList();
      hideLoader();
      if (res.code === 200) {
        setAllStates(
          res.data.states.rows.map(({ StateID, StateName }) => {
            return { label: StateName, value: StateID };
          }) || []
        );
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };

  // ****************************** Fetch All Districts *****************************************

  const fetchAllDistricts = async () => {
    showLoader();
    try {
      const res = await getDistrictdropdownList({ stateId: staffData.state });
      hideLoader();
      if (res.code === 200) {
        setAllDistricts(
          res.data.districts.rows.map(({ DistrictID, DistrictName }) => {
            return { label: DistrictName, value: DistrictID };
          }) || []
        );
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };

  // ****************************** Fetch All Talukas *****************************************

  const fetchAllTalukas = async () => {
    showLoader();
    console.log(staffData.district);
    try {
      const res = await getTalukadropdownList({
        districtId: staffData.district,
      });
      hideLoader();
      if (res.code === 200) {
        setAllTalukas(
          res.data.Taluka.rows.map(({ TalukaID, TalukaName }) => {
            return { label: TalukaName, value: TalukaID };
          }) || []
        );
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };

  // ****************************** Fetch All Talukas *****************************************

  const fetchAllRoles = async () => {
    showLoader();
    console.log(staffData.district);
    try {
      const res = await getUserRoledropdownList({});
      hideLoader();
      if (res.code === 200) {
        setAllRoles(
          res.data.userTypes.rows.map(({ UserTypeID, UserTypeName }) => {
            return { label: UserTypeName, value: UserTypeID };
          }) || []
        );
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };

  useLayoutEffect(() => {
    fetchAllStates();
    fetchAllRoles();
    fetchAllData();
  }, []);

  useEffect(() => {
    if (staffData && staffData.state) {
      fetchAllDistricts();
      if (staffData && staffData.district) {
        fetchAllTalukas();
      }
    } else {
      // toast.error("Please Select State")
    }
  }, [staffData.state, staffData.district]);

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    // if (!profileImage) {
    //   errorField["profile"] = "Please Select Profile";
    //   formIsValid = false;
    // }
    if (!staffData.firstName) {
      errorField["firstName"] = "Please Enter First Name";
      formIsValid = false;
    }
    if (!staffData.lastName) {
      errorField["lastName"] = "Please Enter Last Name";
      formIsValid = false;
    }

    if (!staffData.role) {
      errorField["role"] = "Please Select Role";
      formIsValid = false;
    }
    if (!staffData.EmployeeCode) {
      errorField["EmployeeCode"] = "Please Enter Employee Code";
      formIsValid = false;
    }

    if (!staffData.email) {
      errorField["email"] = "Please Enter Email";
      formIsValid = false;
    } else if (!validateEmail(staffData.email)) {
      errorField["email"] = "Please Enter Valid Email";
      formIsValid = false;
      setIsValidEmail(false);
    }

    if (!staffData.mobile) {
      errorField["mobile"] = "Please Enter Mobile No.";
      formIsValid = false;
    } else if (staffData.mobile.length !== 10) {
      errorField["mobiles"] = "Mobile number must be 10 digits";
      formIsValid = false;
    }
    //  else if (staffData.mobile.length !== 10) {
    //   errorField["mobiles"] = "Mobile number must be 10 digits";
    //   formIsValid = false;
    // }
    if (!staffData.city) {
      errorField["city"] = "Please Enter City";
      formIsValid = false;
    }
    if (!staffData.state) {
      errorField["state"] = "Please Select State";
      formIsValid = false;
    }
    if (!staffData.district) {
      errorField["district"] = "Please Select District";
      formIsValid = false;
    }
    if (!staffData.taluka) {
      errorField["taluka"] = "Please Select Taluka";
      formIsValid = false;
    }
    if (!staffData.zipcode) {
      errorField["zipcode"] = "Please Enter Zipcode";
      formIsValid = false;
    }
    if (!staffData.address) {
      errorField["address"] = "Please Enter Address";
      formIsValid = false;
    }
    if (!staffData.worklocation) {
      errorField["worklocation"] = "Please Enter worklocation";
      formIsValid = false;
    }
    // if (!staffData.userName) {
    //   errorField["userName"] = "Please Enter User Name";
    //   formIsValid = false;
    // }

    setErrorField(errorField);
    return formIsValid;
  };

  //*********************Submit Staff Handler********************************** *//
  const submitStaff = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const res = await UpdateUser({
          UserID:id,
          FirstName: staffData.firstName,
          LastName: staffData.lastName,
          EmailID: staffData.email,
          Mobile: staffData.mobile,
          Address: staffData.address,
          City: staffData.city,
          StateID: staffData.state,
          ZipCode: staffData.zipcode,
          Role: staffData.role,
          EmployeeCode: staffData.EmployeeCode,
          DistrictID: staffData.district,
          TalukaID: staffData.taluka,
          WorkLocation: staffData.worklocation,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  //   onChange Handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setIsValidEmail(true);
    }
    if (name === "zipcode") {
      setStaffData({ ...staffData, [name]: value.replace(/\D/g, "") });
    } else if (name === "city" || name === "state") {
      setStaffData({
        ...staffData,
        [name]: value.replace(/[^A-Za-z ]/gi, "").replace(/\s+/g, " "),
      });
    } else if (name === "mobile") {
      // Mobile number validation
      const numericValue = value.replace(/\D/g, "");
      setStaffData({ ...staffData, [name]: numericValue });

      if (numericValue.length === 10) {
        setMobError("");
      } else {
        setMobError("Mobile number must be 10 digits");
      }
    } else {
      setStaffData({ ...staffData, [name]: value });
    }
  };

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5 d-flex justify-content-between">
                <h4 className="Title">
                  <Link to={-1}>
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  Update User
                </h4>
              </div>
            </div>
            {loader}
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitStaff}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="firstName"
                                value={staffData.firstName}
                                onChange={onChangeHandler}
                                placeholder="Enter First Name"
                                className={`form-control `}
                                maxLength={30}
                                label="First Name"
                                error={errorField.firstName}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="lastName"
                                value={staffData.lastName}
                                onChange={onChangeHandler}
                                placeholder="Enter Last Name"
                                className={`form-control `}
                                maxLength={30}
                                label="Last Name"
                                error={errorField.lastName}
                                required
                              />
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Select
                                name="role"
                                placeholder="Select Role"
                                onChange={onChangeHandler}
                                value={staffData.role}
                                className={`form-control `}
                                label={"Role"}
                                error={errorField.role}
                                required
                              >
                                <option value="">Select Role</option>
                                {allRoles &&
                                  allRoles.map(({ label, value }) => {
                                    return (
                                      <option value={value} key={value}>
                                        {label}
                                      </option>
                                    );
                                  })}
                              </Select>
                            </div>

                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="EmployeeCode"
                                value={staffData.EmployeeCode}
                                onChange={onChangeHandler}
                                placeholder="Enter Employee Code"
                                className={`form-control `}
                                maxLength={30}
                                label="Employee Code"
                                error={errorField.EmployeeCode}
                                required
                              />
                            </div>
                            <div
                              htmlFor="email"
                              className="col-sm-6 col-form-label"
                            >
                              <Input
                                type="email"
                                name="email"
                                value={staffData.email}
                                onChange={onChangeHandler}
                                placeholder="Enter Email"
                                className={`form-control ${
                                  ((!staffData.email && errorField.email) ||
                                    !isValidEmail) &&
                                  "is-invalid"
                                }`}
                                maxLength={40}
                                label={"Email ID"}
                                error={errorField.email}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="mobile"
                                value={staffData.mobile}
                                onChange={onChangeHandler}
                                maxLength={10}
                                placeholder="Enter Mobile"
                                className={`form-control ${mobError && "is-invalid"}`}
                                label={"Mobile"}
                                error={errorField.mobile}
                                required
                              />
                              {mobError && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {mobError}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-12 col-form-label">
                          <TextArea
                            type="text"
                            name="address"
                            value={staffData.address}
                            onChange={onChangeHandler}
                            placeholder="Enter Address"
                            className={`form-control `}
                            label="Address"
                            error={errorField.address}
                            rows={7}
                            required
                          />
                        </div>
                        <label style={{ fontWeight: "500", marginTop: "10px" }}>
                          Personal Information
                        </label>

                        <div className="col-sm-4 col-form-label">
                          <Select
                            name="state"
                            placeholder="Select State"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setStaffData({ ...staffData, [name]: value });
                            }}
                            value={staffData.state}
                            className={`form-control `}
                            label={"State"}
                            error={errorField.state}
                            required
                          >
                            <option value="">Select State</option>
                            {allStates &&
                              allStates.map(({ label, value }) => {
                                return (
                                  <option value={value} key={value}>
                                    {label}
                                  </option>
                                );
                              })}
                          </Select>
                        </div>

                        <div className="col-sm-4 col-form-label">
                          <label className="my-1">Select District</label>
                          {/* <span className="text-danger"> *</span> */}
                          <Select
                            name="district"
                            placeholder="Select District"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              setStaffData({ ...staffData, [name]: value });
                            }}
                            value={staffData.district}
                            className={`form-control `}
                            onClick={() => {
                              if (!staffData.state) {
                                toast.error("Please Select State");
                              }
                            }}
                            label={"District"}
                            error={errorField.district}
                            required
                          >
                            <option value="">Select District</option>
                            {allDistricts &&
                              allDistricts.map(({ label, value }) => {
                                return (
                                  <option value={value} key={value}>
                                    {label}
                                  </option>
                                );
                              })}
                          </Select>
                        </div>

                        <div className="col-sm-4 col-form-label">
                          <label className="my-1">Taluka</label>
                          <select
                            className={`form-control ${
                              allTalukas.length <= 0 &&
                              errorField.taluka &&
                              "is-invalid"
                            }`}
                            name="taluka"
                            onClick={() => {
                              if (!staffData.state || !staffData.district) {
                                toast.error("Please Select State and District");
                              }
                            }}
                            value={staffData.taluka}
                            onChange={(e) =>
                              setStaffData({
                                ...staffData,
                                [e.target.name]: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Taluka</option>
                            {allTalukas.map(({ label, value }) => (
                              <option value={value} key={value}>
                                {label}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errorField.taluka}
                          </div>
                        </div>

                        <div className="col-sm-4 col-form-label">
                          <Input
                            type="text"
                            name="city"
                            value={staffData.city}
                            onChange={onChangeHandler}
                            placeholder="Enter City"
                            className={`form-control `}
                            maxLength={40}
                            label={"City"}
                            error={errorField.city}
                            required
                          />
                        </div>
                        <div className="col-sm-4 col-form-label">
                          <Input
                            type="text"
                            name="zipcode"
                            placeholder="Enter Zipcode"
                            className={`form-control `}
                            value={staffData.zipcode}
                            onChange={onChangeHandler}
                            maxLength={6}
                            label={"Zipcode"}
                            error={errorField.zipcode}
                            required
                          />
                        </div>

                        <div className="col-sm-4 col-form-label">
                          <Input
                            type="text"
                            name="worklocation"
                            value={staffData.worklocation}
                            onChange={onChangeHandler}
                            placeholder="Enter worklocation"
                            className={`form-control `}
                            maxLength={40}
                            label={"Work Location"}
                            error={errorField.worklocation}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <Button type="submit" {...submitButtonElement}>
                      Update User
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
